var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoPenSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.05859 10.2531L5.68359 10.8606L6.24609 7.4406L12.6923 1.01686C12.7969 0.911411 12.9214 0.827717 13.0584 0.770602C13.1955 0.713488 13.3426 0.684082 13.4911 0.684082C13.6396 0.684082 13.7867 0.713488 13.9237 0.770602C14.0608 0.827717 14.1853 0.911411 14.2898 1.01686L15.4823 2.20936C15.5878 2.31394 15.6715 2.43836 15.7286 2.57546C15.7857 2.71255 15.8151 2.85959 15.8151 3.0081C15.8151 3.15662 15.7857 3.30366 15.7286 3.44075C15.6715 3.57785 15.5878 3.70227 15.4823 3.80685L9.05859 10.2531Z",
    stroke: "white",
    strokeWidth: 1.12651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1211 10.8154V14.1904C14.1211 14.4888 14.0026 14.7749 13.7916 14.9859C13.5806 15.1969 13.2945 15.3154 12.9961 15.3154H2.30859C2.01023 15.3154 1.72408 15.1969 1.5131 14.9859C1.30212 14.7749 1.18359 14.4888 1.18359 14.1904V3.50293C1.18359 3.20456 1.30212 2.91841 1.5131 2.70743C1.72408 2.49646 2.01023 2.37793 2.30859 2.37793H5.68359",
    stroke: "white",
    strokeWidth: 1.12651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPenSelected);
export default __webpack_public_path__ + "static/media/ico_pen_selected.22a927520f5512e0e6ff3800977a61a4.svg";
export { ForwardRef as ReactComponent };